import React, { useRef } from 'react';
import style from './index.module.css';
import CountUp from 'react-countup';
import { getImage } from '../../utils/utils';
import { motion, useInView } from 'framer-motion';
import { useTheme } from '@mui/material/styles';

const Counter = (props) => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, amount: 0.5 });

	return (
		<motion.div 
			ref={ref}
			initial={{ opacity: 0, y: 30 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true }}
			whileHover={{ y: -5 }}
			className={style.counter}
			style={{
				backgroundColor: isDark ? 'rgba(255, 255, 255, 0.03)' : '#fff',
				boxShadow: isDark ? '0 10px 30px rgba(0,0,0,0.3)' : '0 10px 30px rgba(0,0,0,0.05)',
			}}
		>
			<div className={style.imageSection}>
				<motion.img
					whileHover={{ scale: 1.1, rotate: -5 }}
					className={style.firstImageStyle}
					src={getImage(props.firstImage)}
					alt='Counter icon 1'
				/>
				<motion.img
					whileHover={{ scale: 1.1, rotate: 5 }}
					className={style.secondImageStyle}
					src={getImage(props.secondImage)}
					alt='Counter icon 2'
				/>
			</div>
			<div className={style.countContainer}>
				{isInView ? (
					<CountUp
						className={style.countText}
						style={{ color: theme.palette.primary.main }}
						start={0}
						end={props.count}
						duration={2.5}
						suffix={props.suffix}
					/>
				) : (
					<span className={style.countText} style={{ color: theme.palette.primary.main }}>0{props.suffix}</span>
				)}
			</div>
			<h3 style={{ color: theme.palette.text.secondary }}>{props.content}</h3>
		</motion.div>
	);
};

export default Counter;
